'use strict';

import { Entity } from './Entity';

export class IpList extends Entity {
  protected id;

  protected ip;

  protected users;

  protected staff;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.ip = data.ip;

    this.users = data.users;

    this.staff = data.staff;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getIp() {
    return this.ip;
  }

  public setIp(ip) {
    this.ip = ip;

    return this;
  }

  public getUsers() {
    return this.users;
  }

  public setUsers(users) {
    this.users = users;

    return this;
  }

  public getStaff() {
    return this.staff;
  }

  public setStaff(staff) {
    this.staff = staff;

    return this;
  }
}
